import '@babel/polyfill'
import React from 'react'
import { render } from 'react-dom'
import './App.css'

import App from '#root/components/App'

render(<App />, document.getElementById('app'))
